import { put, call, takeEvery } from 'redux-saga/effects'
import { postImpressions } from '@/core/apiModules/impressions'
import { impressionsModule } from '../modules'
import { errorHandler } from '@/core/helpers/errorHelpers'

function* sendSaga({ payload }) {
  try {
    // Make sure there's something to send
    if (payload.data.length > 0) {
      // Clean the store by removing the impressions that were already sent
      yield put(impressionsModule.clear(payload.data.map(impr => impr.id)))
      // Remove the ids from the data that is sent to the server
      yield postImpressions(payload.companyId, { impressions: payload.data.map(impr => ({ ...impr, id: undefined })) })
    }
  } catch (err) {
    yield call(errorHandler, err)
  }
}

export default function* watchImpressionsSaga() {
  yield takeEvery(impressionsModule.SEND, sendSaga)
}
